import { render, staticRenderFns } from "./MaskOrderSubmission.vue?vue&type=template&id=9c1472ec&scoped=true&"
import script from "./MaskOrderSubmission.vue?vue&type=script&lang=js&"
export * from "./MaskOrderSubmission.vue?vue&type=script&lang=js&"
import style0 from "./MaskOrderSubmission.vue?vue&type=style&index=0&id=9c1472ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1472ec",
  null
  
)

export default component.exports